module.exports = __webpack_public_path__ + "img/click.a712e2f8.png";